import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';

export type VbButtonVariant = 'primary' | 'secondary' | 'success' | 'warning' | 'danger' | 'info' | 'text' | 'link';
export type VbButtonSize = 'small' | 'medium' | 'large';

@Component({
  selector: 'vb-button',
  standalone: true,
  imports: [CommonModule, ButtonModule, TooltipModule],
  templateUrl: './vb-button.component.html',
  styleUrls: ['./vb-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.Emulated
})
export class VbButtonComponent {
  @Input() label = '';
  @Input() icon = '';
  @Input() iconPos: 'left' | 'right' | 'top' | 'bottom' = 'left';
  @Input() variant: VbButtonVariant = 'primary';
  @Input() size: VbButtonSize = 'medium';
  @Input() disabled = false;
  @Input() loading = false;
  @Input() tooltip = '';
  @Input() tooltipPosition: 'top' | 'bottom' | 'left' | 'right' = 'top';
  @Input() type: 'button' | 'submit' | 'reset' = 'button';
  @Input() rounded = false;
  @Input() raised = false;
  @Input() fullWidth = false;
  @Input() outlined = false;

  @Output() btnClick = new EventEmitter<MouseEvent>();

  onClick(event: MouseEvent): void {
    if (!this.disabled && !this.loading) {
      this.btnClick.emit(event);
    }
  }

  get buttonClasses(): string {
    const classes = ['vb-btn'];
    classes.push(`vb-btn--${this.variant}`);
    classes.push(`vb-btn--${this.size}`);

    if (this.outlined) classes.push('vb-btn--outlined');
    if (this.rounded) classes.push('vb-btn--rounded');
    if (this.raised) classes.push('vb-btn--raised');
    if (this.fullWidth) classes.push('vb-btn--full-width');
    if (this.loading) classes.push('vb-btn--loading');
    if (this.disabled) classes.push('vb-btn--disabled');

    return classes.join(' ');
  }
}
